/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Organizations_Sync_FailedInputs */

const en_queue_organizations_sync_failed = /** @type {(inputs: Queue_Organizations_Sync_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customers and suppliers not in Business Central`)
};

/**
* | output |
* | --- |
* | "Customers and suppliers not in Business Central" |
*
* @param {Queue_Organizations_Sync_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_organizations_sync_failed = /** @type {((inputs?: Queue_Organizations_Sync_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Organizations_Sync_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_organizations_sync_failed(inputs)
});